import { render, staticRenderFns } from "./TermsOfServiceContent.vue?vue&type=template&id=2294396e&scoped=true"
import script from "./TermsOfServiceContent.vue?vue&type=script&lang=js"
export * from "./TermsOfServiceContent.vue?vue&type=script&lang=js"
import style0 from "./TermsOfServiceContent.vue?vue&type=style&index=0&id=2294396e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2294396e",
  null
  
)

export default component.exports